module.exports = {"id":"162280","name":"Adrian Mierzejewski","rating":"75","photo":"./data/images/photos/0/162280.png","club":{"name":"Sydney FC","logo":"./data/images/clubs/SydneyFC.png"},"positions":["MOC","MD","MG"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AdrianMierzejewski0.json
// module id = 109
// module chunks = 0